export class File {
  constructor(item) {
    this.item = item;
    this.itemDefault = item.innerHTML;
  }
  init(success) {
    this.success = success;
    this.input = this.item.querySelector('input[type]');
    this.content = this.item.querySelector('.file-wrapper__content');
    this.svg = this.item.querySelector('svg');
    this.events(() => {
      success(this.input)
    });
    this.inited = true;
  }
  reset() {
    this.input.value = '';
    this.input.dispatchEvent(new CustomEvent('reset'));
    this.item.classList.remove('is-filled');
    this.item.innerHTML = this.itemDefault;
    this.init(this.success);
  }
  error() {
    this.input.value = '';
    this.dropEl = document.createElement('div');
    this.dropEl.classList.add('b-popover', 'error');
    this.dropEl.innerHTML = `Размер файла не более ${this.input.size / 1024 / 1024} мегабайт`;
    this.input.insertAdjacentElement('afterend', this.dropEl);
    this.drop = UIkit.drop(this.dropEl, {
      pos: 'top-left',
      mode: 'click'
    });
    this.drop.show();
  }
  events(success) {
    this.input.addEventListener('reset', () => {
      success();
    });
    this.input.addEventListener('change', () => {
      if (!this.input.files.length) return;
      if (this.input.files[0].size <= this.input.size) {
        this.item.classList.add('is-filled');
        this.content.innerHTML = this.input.files[0].name;
        this.svg.children[0].setAttribute('xlink:href', '#close');
        this.svg.setAttribute('width', '21');
        this.svg.setAttribute('height', '21');
        success();
      } else {
        this.error();
        setTimeout(() => this.reset(), 3000);
      }
    });
    this.svg.addEventListener('click', () => {
      if (!this.input.files.length) return;
      this.reset();
    })
  }
}
